import { render, staticRenderFns } from "./queryTableDialog.vue?vue&type=template&id=37c51e1c&scoped=true"
import script from "./queryTableDialog.vue?vue&type=script&lang=js"
export * from "./queryTableDialog.vue?vue&type=script&lang=js"
import style0 from "./queryTableDialog.vue?vue&type=style&index=0&id=37c51e1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c51e1c",
  null
  
)

export default component.exports